import { initializeApp } from "firebase/app";
import { getFirestore } from "firebase/firestore";
import { getAuth } from "firebase/auth";

// ✅ YOUR CONFIG
const firebaseConfig = {
  apiKey: "AIzaSyBEEp6Hbg17SSYAyrHJusirtmoX0yGRYNk",
  authDomain: "money-tracker-37a63.firebaseapp.com",
  projectId: "money-tracker-37a63",
  storageBucket: "money-tracker-37a63.appspot.com",
  messagingSenderId: "987905676868",
  appId: "1:987905676868:web:49175be6d74bd20e8ece11"
};

// ❌ REMOVE analytics completely

const app = initializeApp(firebaseConfig);

export const db = getFirestore(app);
export const auth = getAuth(app);